/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown> }} Membership_Freeze_CurrentInputs */

const fr_membership_freeze_current = /** @type {(inputs: Membership_Freeze_CurrentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`En pause du ${i?.start}, reprise le ${i?.end}.`)
};

/**

* @param {Membership_Freeze_CurrentInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_freeze_current = /** @type {((inputs: Membership_Freeze_CurrentInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Freeze_CurrentInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_freeze_current(inputs)
});